import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import {
    type SchemaLoanRequestResolver_Get,
    schemaLoanRequestResolver_GetEuropaceProcessId,
} from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useEuropaceProcessId = (leadId: SchemaLoanRequestResolver_Get['id']) => {
    return useAggregateQuery({
        acl: { loanRequestId: leadId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getEuropaceProcessId,
        schema: schemaLoanRequestResolver_GetEuropaceProcessId,
        searchParams: { id: leadId },
    });
};
